import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Differentiation } from "./components/Differentiation";
import { PracticeAreas } from "./components/PracticeAreas";
import ClientShowcase from "./components/ClientShowcase";
import BlogSection from "./components/Blog/BlogSection";
import FeaturedBlogs from "./components/Blog/FeaturedBlogs";

import PostPage from "./components/Blog/PostPage";
import Footer from "./components/Footer";
import BookConsultation from "./components/BookConsultation";
import Partners from "./components/Partners";
import { useEffect } from "react";
import { AboutUs } from "./components/Aboutus";

// Scroll helper
const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) section.scrollIntoView({ behavior: "smooth" });
};

// Home page component (inline)
const HomePage = ({ posts }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      scrollToSection(location.state.scrollTo);
    }
  }, [location.state]);

  return (
    <>
      <section id="home" className="pt-16">
        <Hero />
      </section>

      <section id="aboutus" className="pt-16">
        <AboutUs />
      </section>

      <section id="whyus" className="pt-16">
        <Differentiation />
      </section>

      <section id="practiceareas" className="pt-16">
        <PracticeAreas />
      </section>

      <section id="partners" className="pt-16">
        <Partners />
      </section>

      <section id="clients" className="pt-16">
        <ClientShowcase />
      </section>

      <section id="insights" className="pt-16">
        <FeaturedBlogs />
      </section>

      <section id="" className="pt-16">
        <BookConsultation />
      </section>

      {/* Footer */}
      <section id="footer" className="pt-16">
        <Footer />
      </section>
    </>
  );
};

export default function App({ posts }) {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <Routes>
          {/* Default homepage */}
          <Route path="/" element={<HomePage posts={posts} />} />

          {/* Client portal homepage */}
          <Route path="/portal" element={<HomePage posts={posts} />} />

          {/* Blog section page */}
          <Route
            path="/insights"
            element={
              <div className="pt-16 max-w-7xl mx-auto px-6">
                <BlogSection />
              </div>
            }
          />

          {/* Individual blog post */}
          <Route path="/blog/:slug" element={<PostPage />} />

         
        </Routes>
      </div>
    </Router>
  );
}
